import React, { useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate, TextFormat } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getEntity } from './scheduling.reducer';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const SchedulingDetail = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getEntity(props.match.params.id));
  }, []);

  const schedulingEntity = useAppSelector(state => state.scheduling.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="schedulingDetailsHeading">
          <Translate contentKey="fleetSenseApp.scheduling.detail.title">Scheduling</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{schedulingEntity.id}</dd>
          <dt>
            <span id="description">
              <Translate contentKey="fleetSenseApp.scheduling.description">Description</Translate>
            </span>
          </dt>
          <dd>{schedulingEntity.description}</dd>
          <dt>
            <span id="type">
              <Translate contentKey="fleetSenseApp.scheduling.type">Type</Translate>
            </span>
          </dt>
          <dd>{schedulingEntity.type}</dd>
          <dt>
            <span id="method">
              <Translate contentKey="fleetSenseApp.scheduling.method">Method</Translate>
            </span>
          </dt>
          <dd>{schedulingEntity.method}</dd>
          <dt>
            <span id="status">
              <Translate contentKey="fleetSenseApp.scheduling.status">Status</Translate>
            </span>
          </dt>
          <dd>{schedulingEntity.status}</dd>
          <dt>
            <span id="startTime">
              <Translate contentKey="fleetSenseApp.scheduling.startTime">Start Time</Translate>
            </span>
          </dt>
          <dd>{schedulingEntity.startTime ? <TextFormat value={schedulingEntity.startTime} type="date" format={APP_DATE_FORMAT} /> : null}</dd>
          <dt>
            <span id="endTime">
              <Translate contentKey="fleetSenseApp.scheduling.endTime">End Time</Translate>
            </span>
          </dt>
          <dd>{schedulingEntity.endTime ? <TextFormat value={schedulingEntity.endTime} type="date" format={APP_DATE_FORMAT} /> : null}</dd>
          <dt>
            <Translate contentKey="fleetSenseApp.scheduling.user">User</Translate>
          </dt>
          <dd>{schedulingEntity.user ? schedulingEntity.user.id : ''}</dd>
          <dt>
            <Translate contentKey="fleetSenseApp.scheduling.truckImplement">Truck Implement</Translate>
          </dt>
          <dd>{schedulingEntity.truckImplement ? schedulingEntity.truckImplement.id : ''}</dd>
          <dt>
            <Translate contentKey="fleetSenseApp.scheduling.company">Company</Translate>
          </dt>
          <dd>{schedulingEntity.company ? schedulingEntity.company.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/scheduling" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/scheduling/${schedulingEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};
